import { render, staticRenderFns } from "./Kleurplaten.vue?vue&type=template&id=5d432a63&scoped=true"
import script from "./Kleurplaten.vue?vue&type=script&lang=js"
export * from "./Kleurplaten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d432a63",
  null
  
)

export default component.exports